<template>
  <div class="flex flex-col flex-1 h-full absolute inset-0">
    <div class="custom-dialog-header">
      <div class="flex items-center gap-2">
        <el-tooltip
          v-if="!showConversations"
          content="Expand conversation list"
          placement="right"
        >
          <i
            class="el-icon-notebook-2 text-lg font-semibold cursor-pointer el-button--text"
            @click="showConversations = true"
          >
          </i>
        </el-tooltip>
        <span class="custom-dialog-title">{{ title }}</span>
      </div>
      <div class="custom-dialog-actions">
        <el-button type="text" @click="handleToggle">
          <i
            :class="
              isFullScreen ? 'fa fa-window-restore' : 'fa fa-window-maximize'
            "
            style="font-size: 18px"
          ></i>
        </el-button>
        <el-button type="text" @click="$emit('close')">
          <i class="el-icon-close" style="font-size: 18px"></i>
        </el-button>
      </div>
    </div>
    <div class="flex-1 flex flex-row gap-4 relative p-4">
      <ChatConversationPanel
        v-show="showConversations"
        ref="conversationPanel"
        :agentId="agentId"
        @select="handleSelectConversation"
        @create="handleNewConversation"
        @collapse="showConversations = false"
      />
      <ChatPanel
        ref="chatPanel"
        :agentId="agentId"
        :conversationId="currentSelectedConversation?.conversationId"
        :showHistory="showHistory"
        :agentParameters="agentParameters"
        :autoSendMessage="autoSendMessage"
        @init-conversation="handleInitConversation"
      />
    </div>
  </div>
</template>

<script>
import ChatConversationPanel from "./ChatConversationPanel.vue";
import ChatPanel from "./ChatPanel.vue";

export default {
  name: "ChatDialog",
  emits: ["max", "min", "close"],
  components: {
    ChatConversationPanel,
    ChatPanel,
  },
  props: {
    title: {
      type: String,
      default: "Chat",
    },
    agent: {
      type: Object,
      default: null,
      required: true,
    },
    conversationId: {
      type: String,
      default: null,
    },
    showHistory: {
      type: Boolean,
      default: true,
    },
    agentParameters: {
      type: Object,
      default: () => ({}),
    },
    autoSendMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentSelectedConversation: null,
      showConversations: true,
      isFullScreen: false,
    };
  },
  computed: {
    agentId() {
      return this.agent?.agent_id || null;
    },
  },
  methods: {
    handleToggle() {
      console.log("Toggling full screen");
      this.isFullScreen = !this.isFullScreen;
      if (this.isFullScreen) {
        this.$emit("max");
      } else {
        this.$emit("min");
      }
    },
    handleSelectConversation(conversation) {
      // 兼容传入对象或id
      this.currentSelectedConversation = conversation;
      // 让 ChatPanel 加载新会话历史
      this.$nextTick(() => {
        const chatPanel = this.$refs.chatPanel;
        if (chatPanel) {
          if ("currentConversationId" in chatPanel) {
            chatPanel.conversation = conversation;
          }
          if (typeof chatPanel.loadHistories === "function") {
            chatPanel.loadHistories();
          }
        }
      });
    },
    handleNewConversation() {
      this.currentSelectedConversation = null;
      this.$nextTick(() => {
        const chatPanel = this.$refs.chatPanel;
        if (chatPanel) {
          chatPanel.newConversation();
        }
      });
    },
    handleInitConversation(conv) {
      this.currentSelectedConversation = conv;
      this.$nextTick(() => {
        const conversationPanel = this.$refs.conversationPanel;
        if (conversationPanel) {
          conversationPanel.selectedId = conv?.conversationId || null;
          conversationPanel.getAgentConversations();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/element-variables.scss";

.scroll-bar {
  flex: 1 1 0;
}

.scroll-bar ::v-deep .el-scrollbar__wrap {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}

.content {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 8px 8px;
}

.content .message-list {
  /* 撑满剩余高度 */
  flex: 1;
  overflow-y: auto;
  padding: 36px 13px 0 13px;
  scroll-behavior: smooth;
}

.bottom-input {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 0 8px;
  border-top: 1px solid #f0f0f0;
}

input {
  height: 38px;
  border-radius: 2px;
  border: 1px solid #d2d2d2;
  margin-right: 10px;
  transition: all 0.2s ease-in-out;
}

input:focus {
  outline: none;
  border-color: #fcb900;
}

.submit-button {
  width: 56px;
  height: 38px;
  border-radius: 2px;
  background-color: #fcb900;
  opacity: 0.6;
  transition: all 0.2s ease-in-out;
}

input:focus ~ .submit-button {
  opacity: 1;
}

.submit-button img {
  width: 22px;
  height: 22px;
  margin: 8px 17px 8px 17px;
}

.custom-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  min-height: 48px;
  border-bottom: 1px solid $--border-color-lighter;

  .custom-dialog-title {
    font-weight: bold;
    font-size: 16px;
  }

  .custom-dialog-actions {
    display: flex;
    align-items: center;
  }
}
</style>
